<template>
  <section class="section-empathy animate-box">
    <div class="empathy-container">
      <div class="side-content">
        <div class="vertical-line"></div>
        <div class="title-group">
          <span class="en-title">THE SILENCE</span>
          <h2>在算法的喧嚣中<br><span class="highlight">保持思考</span></h2>
          <p class="description">
            我们身处信息爆炸的时代，却往往在数字洪流中迷失。来秋致力于打破这些无形的屏障。
          </p>
        </div>
      </div>

      <div class="pain-points">
        <div class="point-item" v-for="(item, index) in problems" :key="index">
          <div class="point-num">0{{ index + 1 }}</div>
          <div class="point-text">
            <h4>{{ item.title }}</h4>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const problems = [
  { title: '信息过载 / Noise', desc: '算法推给你的，真的是你想要的吗？我们拒绝无效堆砌，倡导精准过滤。' },
  { title: '技术孤岛 / Isolation', desc: '代码不应只是冰冷的指令。在孤岛化的开发环境中，我们需要有深度的连接。' },
  { title: '创造力焦虑 / Burnout', desc: '当效率成为唯一的度量衡，灵感便开始枯萎。来秋让创作回归自由。' }
]
</script>

<style scoped>
.section-empathy {
  padding: 120px 10%;
  background: #050505;
  color: #fff;
}

.empathy-container {
  display: flex;
  justify-content: space-between;
  gap: 100px;
}

.side-content {
  flex: 1;
  position: relative;
  padding-left: 30px;
}

.vertical-line {
  position: absolute;
  left: 0;
  top: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(to bottom, #6d5dfc, transparent);
}

.en-title {
  font-size: 0.8rem;
  letter-spacing: 5px;
  color: #6d5dfc;
  font-weight: bold;
}

.side-content h2 {
  font-size: 3.2rem;
  margin: 20px 0;
  line-height: 1.2;
}

.highlight {
  font-weight: 200;
  opacity: 0.6;
}

.description {
  font-size: 1.1rem;
  opacity: 0.5;
  line-height: 1.8;
  max-width: 400px;
}

.pain-points {
  flex: 1;
}

.point-item {
  display: flex;
  gap: 30px;
  margin-bottom: 50px;
  transition: 0.3s;
}

.point-num {
  font-family: 'serif';
  font-size: 1.5rem;
  font-style: italic;
  color: #6d5dfc;
  opacity: 0.8;
}

.point-text h4 {
  font-size: 1.3rem;
  margin-bottom: 10px;
  letter-spacing: 1px;
}

.point-text p {
  font-size: 0.95rem;
  opacity: 0.5;
  line-height: 1.6;
}

@media (max-width: 992px) {
  .empathy-container {
    flex-direction: column;
    gap: 60px;
  }

  .side-content h2 {
    font-size: 2.5rem;
  }
}
</style>